import { LntSelectOption } from '@app/components/base/Select/types'
import { SIZE } from '@app/constants'
import { SEPARATOR } from '@app/constants/separator'

import type { LntSelectProps } from '@app/components/base/Select/types'

export const commonSelectProps: LntSelectProps<string[]> = {
  showArrow: true,
  mode: 'multiple',
  size: SIZE.middle,
  strictValue: true,
  tokenSeparators: [SEPARATOR.newline]
}

export const singleSelectProps: LntSelectProps<string> = {
  showArrow: true,
  size: SIZE.middle,
  strictValue: true
}

export const STATUS_CONFIRMED_FILTER = {
  isConfirmed: 'is_confirmed',
  notConfirmed: 'not_confirmed'
} as const

export const STATUS_MATCHED_PRODUCT_FILTER = {
  isMatchedWithProduct: 'is_matched_with_product',
  notMatchedWithProduct: 'not_matched_with_product'
}

export const confirmedOptions: LntSelectOption[] = [
  { label: 'Подтвержден', value: STATUS_CONFIRMED_FILTER.isConfirmed },
  { label: 'Не подтвержден', value: STATUS_CONFIRMED_FILTER.notConfirmed }
]

export const isMatchedWithProductOptions: LntSelectOption[] = [
  { label: 'Сопоставлен', value: STATUS_MATCHED_PRODUCT_FILTER.isMatchedWithProduct },
  { label: 'Не сопоставлен', value: STATUS_MATCHED_PRODUCT_FILTER.notMatchedWithProduct }
]
